import { createSelector } from '@reduxjs/toolkit';
export const departmentsReducer = createSelector([(state) => state.departmentsRedux], (departments) => departments);
export const departmentsSelector = createSelector(departmentsReducer, (reducer) => {
    return reducer.data;
});
